import hostActions from "./hostActions";
import {
  sendGetDevicesRequest,
  sendGetPlaylistsRequest,
  sendGetPrivateCredentialsRequest,
  sendSelectDeviceRequest,
  sendSetPlaylistRequest,
  sendCreatePartyRequest,
} from "../../../api/votify.api";

export const handleNoDevice = () => {
  return { type: hostActions.NO_DEVICE };
};
export const handleNotAuthorized = () => {
  return { type: hostActions.NOT_AUTHORIZED };
};

export const saveSimpleToken = (jwtToken) => {
  return { type: hostActions.SAVE_JWT_TOKEN, payload: { jwtToken } };
};

export const selectDevice = (device) => {
  return async (dispatch, getState) => {
    const jwtToken = getState().host.jwtToken;
    const partyId = getState().host.partyId;
    dispatch({ type: hostActions.START_SELECT_DEVICE_REQUEST });
    const selectDeviceOption = await sendSelectDeviceRequest(
      device.id,
      partyId,
      jwtToken,
    );
    if (selectDeviceOption.ok) {
      dispatch({
        type: hostActions.SUCCESS_SELECT_DEVICE_REQUEST,
        payload: { device: selectDeviceOption.data.device },
      });
    } else {
      dispatch({ type: hostActions.FAIL_SELECT_DEVICE_REQUEST });
    }
    dispatch({ type: hostActions.END_SELECT_DEVICE_REQUEST });
  };
};

export const getDevices = () => {
  return async (dispatch, getState) => {
    dispatch({ type: hostActions.START_LOAD_DEVICES_REQUEST });
    const jwtToken = getState().host.jwtToken;
    const getDevicesOption = await sendGetDevicesRequest(jwtToken);
    if (getDevicesOption.ok) {
      console.log("getDevices");
      console.log(getDevicesOption);

      dispatch({
        type: hostActions.LOAD_DEVICES,
        payload: { devices: getDevicesOption.data.devices },
      });
    } else {
      dispatch({ type: hostActions.FAIL_LOAD_DEVICES_REQUEST });
    }
    dispatch({ type: hostActions.END_LOAD_DEVICES_REQUEST });
  };
};

export const getPrivateCredentials = (jwtToken) => {
  return async (dispatch) => {
    const credentialsOption = await sendGetPrivateCredentialsRequest(jwtToken);
    if (credentialsOption.ok) {
      dispatch({
        type: hostActions.LOAD_PRIVATE_CREDENTIALS,
        payload: { credentials: credentialsOption.data },
      });
    } else {
      dispatch({ type: hostActions.FAIL_LOAD_PRIVATE_CREDENTIALS });
    }
  };
};

export const getPlaylists = () => {
  return async (dispatch, getState) => {
    dispatch({ type: hostActions.START_LOAD_PLAYLISTS_REQUEST });
    const jwtToken = getState().host.jwtToken;
    const getPlaylistsOption = await sendGetPlaylistsRequest(jwtToken);
    if (getPlaylistsOption.ok) {
      dispatch({
        type: hostActions.SUCCESS_LOAD_PLAYLISTS_REQUEST,
        payload: getPlaylistsOption.data,
      });
    } else {
      dispatch({ type: hostActions.FAIL_LOAD_PLAYLISTS_REQUEST });
    }
    dispatch({ type: hostActions.END_LOAD_PLAYLISTS_REQUEST });
  };
};
export const setPlaylist = (playlist) => {
  return async (dispatch, getState) => {
    dispatch({
      type: hostActions.START_SET_PLAYLIST_REQUEST,
      payload: { playlist },
    });
    const jwtToken = getState().host.jwtToken;
    const partyId = getState().host.partyId;
    const getPlaylistsOption = await sendSetPlaylistRequest(
      playlist.id,
      playlist.owner.id,
      partyId,
      jwtToken,
    );
    if (getPlaylistsOption.ok) {
      dispatch({
        type: hostActions.SUCCESS_SET_PLAYLIST_REQUEST,
        payload: { playlist },
      });
    } else {
      dispatch({ type: hostActions.FAIL_SET_PLAYLIST_REQUEST });
    }
    dispatch({ type: hostActions.END_SET_PLAYLIST_REQUEST });
  };
};

export const setPartyName = (partyName) => {
  return async (dispatch, getState) => {
    dispatch({ type: hostActions.START_SET_PARTY_NAME_REQUEST });
    const jwtToken = getState().host.jwtToken;
    const { ok, error, data: partyObject } = await sendCreatePartyRequest(
      jwtToken,
      partyName,
    );
    if (!ok) {
      dispatch({
        type: hostActions.FAIL_SET_PARTY_NAME_REQUEST,
        payload: { error },
      });
    } else {
      dispatch({
        type: hostActions.SUCCESS_SET_PARTY_NAME_REQUEST,
        payload: { ...partyObject },
      });
    }
    dispatch({ type: hostActions.END_SET_PARTY_NAME_REQUEST });
  };
};

export const setWelcomeMenuSeen = () => {
  return { type: hostActions.SET_WELCOME_MENU_SEEN };
};
